// extracted by mini-css-extract-plugin
export var lg = "_2z-4";
export var md = "_2z-3";
export var sm = "_2z-2";
export var xs = "_2z-1";
export var xxs = "_2z-0";